"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Compare32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M20.791 23.389a6.363 6.363 0 01-2.404.472 6.39 6.39 0 116.389-6.389 6.415 6.415 0 01-3.985 5.917zM3.025 22.061L3 7.071c0-.287.208-.789.411-.992L6 3.452c.199-.2.717-.452 1.001-.452H17l.012 7.212a7.391 7.391 0 00-4.433 11.828c-4.087 0-9.554.019-9.554.021zm26.349 4.433L24.5 21.621a7.39 7.39 0 00-6.49-11.528L18 3.03C17.999 2.47 17.549 2 16.996 2H7.001c-.547 0-1.319.358-1.708.748L2.704 5.356c-.392.392-.705 1.165-.704 1.717l.025 14.963c.001.545.45.964 1.003.964h10.457a7.36 7.36 0 008.061 1.144l5.089 5.09a.779.779 0 001.099.004l1.644-1.644a.776.776 0 00-.004-1.1z" }),
    react_1.default.createElement("path", { d: "M7.024 7.441h.502l-.021-4.443-1 .005.019 3.941.5-.502H3v1z" }))); };
var StyledCompare32 = styled_components_1.default(Compare32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCompare32;
var templateObject_1;
//# sourceMappingURL=Compare32.js.map